import React from 'react';
import { Helmet } from 'react-helmet';
import BlogIndex from './BlogIndex';

const Blog = () => (
  <>
    <Helmet>
      <title>Blog | MilaajBrandset</title>
      <meta
        name="description"
        content="Read our latest blog posts on digital marketing, web development, and other topics related to enhancing your business online presence."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, blog, digital marketing, web development, business insights, industry news"
      />
      <meta property="og:title" content="Blog | MilaajBrandset" />
      <meta
        property="og:description"
        content="Read our latest blog posts on digital marketing, web development, and other topics related to enhancing your business online presence."
      />
    </Helmet>
    <BlogIndex />
  </>
);

export default Blog;